import { dataLayerPush } from '@r1-frontend/analytics/dataLayerPush';
import { ACTIONS, CATEGORIES, EVENTS } from '@r1-frontend/shared/constants/analytics';
import { btnTypes } from '@r1-frontend/ui-react/components/buttons/baseButton';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { ThemeProvider } from 'styled-components';

import ChannelListPopup from '~/src/components/Bundles/ChannelListPopup';
import { FiltersForTariffs } from '~/src/components/FiltersForTariffs';
import { TariffCardPlug } from '~/src/components/TariffCardPlug';
import {
    EFilterIds,
    ETariffTypes,
    getInitialFilterItems,
} from '~/src/components/TariffsFilters/filterConstants';
import { LS_TARRIFFS_ACTIVE } from '~/src/constants';
import {
    PATH_BUNDLES_LINK_CITY,
    PATH_INTERNET_LINK_CITY,
    TAB_FLAT,
    TAB_VILLAGE,
} from '~/src/features/index/Tariffs/constants';
import { selectCompanyName } from '~/src/store/selectors/city';
import { selectTariffsByType } from '~/src/store/selectors/filteredBundles';

import * as ST from './styled';

// TODO удалить при решении https://ticket.ertelecom.ru/browse/WEB-48188
export const CINEMA_CONTENT_IDS = [102277, 104106, 104317, 101261, 100576];

// Компонент требует существенного рефакторинга. Временно перенес всю логику как есть
class Tariffs extends Component {
    constructor(props) {
        super(props);

        const { cityBundles, villageBundles, cityInternet, villageInternet } = this.getFilteredTariffs();

        const hasCityTariffs = !!cityBundles?.length || !!cityInternet?.length;
        const hasVillageTariffs = !!villageBundles?.length || !!villageInternet?.length;

        const tariffs = {
            hasMonoCityTariffs: !!cityInternet?.length,
            hasMonoVillageTariffs: !!villageInternet?.length,
            hasBundlesCityTariffs: !!cityBundles?.length,
            hasBundlesVillageTariffs: !!villageBundles?.length,
        };

        this.state = {
            tariffFilter: hasVillageTariffs && !hasCityTariffs ? 'village' : 'city',
            activeTariffFilterItem: hasVillageTariffs && !hasCityTariffs ? 1 : 0,
            hasVillageTariffs,
            hasCityTariffs,
            tariffs,
            filters: getInitialFilterItems(props?.filterForTariff || ETariffTypes.FILTER_BUNDLE),
            filteredTariffs: {
                cityBundles,
                villageBundles,
                cityInternet,
                villageInternet,
            },
            popup: {
                active: false,
                texts: {},
            },
            isChannelPopupOpen: false,
            selectedTariff: null,
        };
    }

    componentDidUpdate(prevProps) {
        if (prevProps.preparedTariffs.cityBundles.length !== this.props.preparedTariffs.cityBundles.length ||
            prevProps.preparedTariffs.villageBundles.length !== this.props.preparedTariffs.villageBundles.length ||
            prevProps.preparedTariffs.cityInternet.length !== this.props.preparedTariffs.cityInternet.length ||
            prevProps.preparedTariffs.villageInternet.length !== this.props.preparedTariffs.villageInternet.length
        ) {
            this.setState({
                filteredTariffs: this.getFilteredTariffs(),
            });
        }
    }

    render() {
        const {
            onMenuTabClick,
            getTariffsWithFilters,
            onToggleFilter,
            onClickViewAllHandler,
            onChannelsClickHandler,
            getCombinedUniqueArray,
            onCloseChannelsPopup,
        } = this;

        const { city, pageTitle, companyName } = this.props;

        const {
            activeTariffFilterItem,
            tariffFilter,
            hasCityTariffs,
            hasVillageTariffs,
            tariffs,
            filters,
            filteredTariffs: {
                cityBundles,
                villageBundles,
                cityInternet,
                villageInternet,
            },
            isChannelPopupOpen,
            selectedTariff,
        } = this.state;

        const title = pageTitle || `Провайдер ${companyName} в ${city.cityIn}`;
        const showTV = filters.find(filter => filter.id === EFilterIds.FILTER_BUNDLE)?.checked;
        const showInternet = filters.find(filter => filter.id === EFilterIds.FILTER_INTERNET)?.checked;
        const currButtonLink = showTV ? PATH_BUNDLES_LINK_CITY : PATH_INTERNET_LINK_CITY;

        const isVillage = tariffFilter === 'village';
        const menuItems = [
            {
                text: TAB_FLAT,
                action: onMenuTabClick.bind(this, 'city', 0),
            },
            {
                text: TAB_VILLAGE,
                action: onMenuTabClick.bind(this, 'village', 1),
            },
        ];

        // TODO при рефакторинге страницы логику currentTariffs нужно вынести в селектор редакса

        let currentTariffs;

        const currBundles = (isVillage && tariffs.hasBundlesVillageTariffs)
            ? villageBundles
            : cityBundles;

        const currInternet = (isVillage && tariffs.hasMonoVillageTariffs)
            ? villageInternet
            : cityInternet;


        const villageUnique = getCombinedUniqueArray(villageBundles, villageInternet);
        const cityUnique = cityBundles || getCombinedUniqueArray(cityBundles, cityInternet);
        const allTariffs = isVillage ? villageUnique : cityUnique;

        if (showTV) {
            currentTariffs = currBundles.filter(item => !(item.alias === 'constructor' && item.type === 'internet') && item.type === 'bundles');
        } else if (showInternet) {
            currentTariffs = currInternet;
        } else {
            currentTariffs = allTariffs.filter(item => !(item.alias === 'constructor' && item.type === 'bundles'));
        }

        const currentFilteredTariffs = getTariffsWithFilters(currentTariffs);

        return <div {...this.props}>
            <ST.TariffTitle>{title}</ST.TariffTitle>
            {hasCityTariffs && (
                <FiltersForTariffs
                    activeItem={activeTariffFilterItem}
                    hasCityTariffs={hasCityTariffs}
                    hasVillageTariffs={hasVillageTariffs}
                    tariffSwitcherData={menuItems}
                    tariffFiltersData={filters}
                    onToggleFilter={onToggleFilter}
                />
            )}

            <ThemeProvider theme={ST.theme}>
                {currentFilteredTariffs.length
                    ? <ST.STariffLine
                        baseTariffs={currentFilteredTariffs}
                        openPopup={onChannelsClickHandler}
                    />
                    : <TariffCardPlug/>
                }
                <ST.StyledButton
                    type={btnTypes.PRIMARY}
                    text={'Смотреть все тарифы'}
                    href={currButtonLink}
                    onClick={onClickViewAllHandler}
                />
            </ThemeProvider>
            <ChannelListPopup
                isOpen={isChannelPopupOpen}
                onClose={onCloseChannelsPopup}
                freePackets={selectedTariff?.freePackets}
            />
        </div>;
    }

    getFilteredTariffs() {
        const { cityBundles, villageBundles, cityInternet, villageInternet } = this.props.preparedTariffs;

        const getAvailableOnMainPage = tariffs => tariffs.filter(tariff => tariff.availableOnMainPage);
        const cityBundlesAvailable = getAvailableOnMainPage(cityBundles);
        const villageBundlesAvailable = getAvailableOnMainPage(villageBundles);
        const cityInternetAvailable = getAvailableOnMainPage(cityInternet);
        const villageInternetAvailable = getAvailableOnMainPage(villageInternet);

        return {
            cityBundles: cityBundlesAvailable?.length ? cityBundlesAvailable : [],
            villageBundles: villageBundlesAvailable?.length ? villageBundlesAvailable : [],
            cityInternet: cityInternetAvailable?.length ? cityInternetAvailable : [],
            villageInternet: villageInternetAvailable?.length ? villageInternetAvailable : [],
        };
    }

    getTariffsWithFilters = (tariffs) => {
        const { filters } = this.state;

        const cinemaFilter = filters.find(filter => filter.id === EFilterIds.FILTER_ONLINE_CINEMA)?.checked;
        const gamesAndServicesFilter = filters.find(filter => filter.id === EFilterIds.FILTER_GAMES_AND_SERVICES)?.checked;
        const showTv =  filters.find(filter => filter.id === EFilterIds.FILTER_BUNDLE)?.checked;
        const tariffConstructorBundles = tariffs.filter(item => item.alias === 'constructor' && item.type === 'bundles');
        const tariffConstructorInternet = tariffs.filter(item => item.alias === 'constructor' && item.type === 'internet');
        let filteredTariffs = [...tariffs];
        const isCinemaTariff = (tariff) => tariff.offerContents.some((item) => CINEMA_CONTENT_IDS.includes(item.service_id));

        if (cinemaFilter) {
            const cinemaTariff = filteredTariffs.filter((tariff) => isCinemaTariff(tariff) || tariff.title.startsWith('Развлекательный'));
            filteredTariffs = showTv ? [...tariffConstructorBundles, ...cinemaTariff] : [...tariffConstructorInternet, ...cinemaTariff];
        }

        if (gamesAndServicesFilter) {
            const gamingTariff = filteredTariffs.filter((tariff) => tariff.title.startsWith('Гейминг') || tariff.title.startsWith('Развлекательный'));
            filteredTariffs = showTv ? [...tariffConstructorBundles, ...gamingTariff] : [...tariffConstructorInternet, ...gamingTariff];
        }

        return filteredTariffs;
    };

    onMenuTabClick(tariffFilter, activeTariffFilterItem) {
        this.setState({ tariffFilter, activeTariffFilterItem }, () => {
            localStorage.setItem(
                LS_TARRIFFS_ACTIVE,
                JSON.stringify({
                    tariffFilterItem: this.state.activeTariffFilterItem,
                    tariffFilter,
                }),
            );
        });

        const filteredBy = tariffFilter === 'city' ? 'apartment' : tariffFilter;

        dataLayerPush({
            event: EVENTS.UAevent,
            category: CATEGORIES.tariffCards,
            action: `${ACTIONS.click} ${filteredBy}`,
        });

        const { tariffs, filters } = this.state;

        const filtersBuffer = [...filters];
        const tvFilter = filtersBuffer.find(filter => filter.id === EFilterIds.FILTER_BUNDLE);
        const isOnlyInternetRadio = !tvFilter.checked;

        if (tariffFilter === 'city') {
            if (isOnlyInternetRadio && !tariffs.hasMonoCityTariffs) {
                tvFilter.checked = true;
                tvFilter.disabled = true;
            } else {
                tvFilter.checked = true;
                tvFilter.disabled = false;
            }
            if (!isOnlyInternetRadio && !tariffs.hasBundlesCityTariffs) {
                tvFilter.checked = false;
                tvFilter.disabled = true;
            }
        } else {
            if (isOnlyInternetRadio && !tariffs.hasMonoVillageTariffs) {
                tvFilter.checked = true;
                tvFilter.disabled = true;
            }
            if (!isOnlyInternetRadio && !tariffs.hasBundlesVillageTariffs) {
                tvFilter.checked = false;
                tvFilter.disabled = true;
            }
        }

        this.setState({ filters: filtersBuffer });
    }

    onToggleFilter = (id) => {
        const filtersBuffer = [...this.state.filters];
        const currentFilter = filtersBuffer.find(filter => filter.id === id);

        if (currentFilter) {
            const prevFilter = currentFilter.alternative && filtersBuffer.find(el => el.alternative && el.checked);
            if (prevFilter && prevFilter.id !== currentFilter.id) {
                prevFilter.checked = false;
                dataLayerPush({
                    event: EVENTS.UAevent,
                    category: CATEGORIES.tariffCards,
                    action: `remove filter ${prevFilter.id}`,
                    label: `${prevFilter.label}`,
                });
            }
            const newState = !currentFilter.checked;
            currentFilter.checked = newState;

            dataLayerPush({
                event: EVENTS.UAevent,
                category: CATEGORIES.tariffCards,
                action: `${newState ? 'add' : 'remove'} filter ${currentFilter.id}`,
                label: `${currentFilter.label}`,
            });
        }

        this.setState({ filters: filtersBuffer });
    };

    onClickViewAllHandler = () => {
        dataLayerPush({
            event: EVENTS.UAevent,
            category: CATEGORIES.tariffCards,
            action: ACTIONS.clickViewAll,
        });
    };

    onChannelsClickHandler = tariff => {
        this.setState({
            isChannelPopupOpen: true,
            selectedTariff: tariff,
        });

        dataLayerPush({
            event: EVENTS.UAevent,
            category: 'Click Bundles on the channel',
            action: 'view channels',
            label: '',
        });
    };


    getCombinedUniqueArray(arr1, arr2) {
        return [...new Map([...arr1, ...arr2].map(item => [item.productId, item])).values()];
    }

    onCloseChannelsPopup = () => {
        this.setState({
            isChannelPopupOpen: false,
            selectedTariff: null,
        });
    };
}

const mapStateToProps = (state) => ({
    city: state.city.currentCity,
    preparedTariffs: selectTariffsByType(state),
    companyName: selectCompanyName(state),
});

export default connect(mapStateToProps)(Tariffs);
